import * as React from "react";
import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {faChevronDown} from "@fortawesome/free-solid-svg-icons";

import "./property-wizard.scss";
import "./context-gathering-pg.scss";

import {cs}               from "@Common/react/chain-services";
import {isDevXd}          from "@Common/ui-components/debug/is-dev";
import {ButtonSpinner}    from "@Common/ui-components/loading-spinners/button-spinner";
import {ScreenLoader}     from "@Common/ui-components/loading-spinners/screen-loader";
import {PropertyDataCard} from "./property-data-card.js";
import {AiSparklesSvg}    from "ai-banner/ai-sparkles-svg";

export const ContextGatheringPage = ({
    idOrder,
    listing = null,
    changeListingModal,
    propertyData,
    propertyWizardData,
    propertyDataChangeHandler,
    generateResults,
    resultsGenerating,
    errorGeneratingSummary
}) => cs(

    ({}) => (
        <div className="context-gathering-page-u56">
            {errorGeneratingSummary ?
                <div className="error-generating-summary">
                    <div className="error-message-and-button">
                        <p>Error generating summary. Please try again.</p>
                        <button
                            type="submit"
                            className="generate-button"
                            disabled={resultsGenerating}
                            onClick={() => generateResults({...propertyData.value})}
                        >
                            {/* TODO: Replace spinner with AI twinkle */}
                            {resultsGenerating ? <ButtonSpinner spinnerColor="white"/> : AiSparklesSvg()}Retry
                        </button>
                    </div>
                </div>
            : null}
            <div className="section-title">Give us some background</div>
            <div className="subtitle">Edit and add information to give the AI more context.</div>
            <div className="listing-container">
                <input
                    type="text"
                    className="listing-select"
                    name="listing_name"
                    value={listing?.location?.streetAddress ? listing?.location?.streetAddress : "Select Listing"}
                    onClick={changeListingModal.show}
                    xd-qa-type="text_field"
                    xd-qa-name="listing_name"
                />
                <div className="down-chevron"><FontAwesomeIcon icon={faChevronDown} /></div>
            </div>
            {(listing && !Object.keys(listing).length) ? <div className="listing-seperator"><hr/>OR<hr/></div> : null}

            <form className="property-wizard-form">
                <PropertyDataCard
                    idOrder={idOrder}
                    listing={listing}
                    propertyData={propertyData}
                    propertyDataChangeHandler={propertyDataChangeHandler}
                    refreshPropertyWizardData={propertyWizardData.reload}
                />
                <div className="section-title">Add more context...</div>
                <textarea
                    className="add_context_textarea"
                    name="additionalContext"
                    value={propertyData?.value?.additionalContext}
                    onChange={(e) => propertyDataChangeHandler(e)}
                    placeholder="Tell the AI anything else you want to highlight about your listing."
                    xd-qa-type="text_area"
                    xd-qa-name="additional_context"
                />
            </form>
            <hr className="title-footer-hr"/>

            <div className="button-container">
                <button
                    type="submit"
                    className="generate-button"
                    disabled={resultsGenerating}
                    onClick={() => generateResults({...propertyData.value})}
                >
                    {/* TODO: Replace spinner with AI twinkle */}
                    {resultsGenerating ? <ButtonSpinner spinnerColor="white"/> : AiSparklesSvg()}Generate
                </button>
            </div>
        </div>
    )
)